import api from "../../../axios/axios";
import { ApiRequest, NetworkTypes, handleAndThrowError } from "../../ApiError";
import { ISelectedTerminal } from "../../terminal/ITerminal";
import { SelectedBooking } from "../IBookings";

export function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export const sendBookingAsync = async (
  selectedBookingsToSend: SelectedBooking[],
  terminals: ISelectedTerminal
) => {
  const nonValidateBookings = selectedBookingsToSend.filter(
    (booking) => booking.bookingValidations.length > 0
  );
  const verifiedBookings = selectedBookingsToSend.filter(
    (booking) => booking.bookingValidations.length === 0
  );
  if (verifiedBookings.length === 0) {
    return nonValidateBookings;
  }
  const url = `/api/v1/phoenixrailbookingacl/forwardbookings`;
  const postData = {
    bookingIds: verifiedBookings.map((b) => b.id),
    terminals: terminals,
  };

  const request: ApiRequest = {
    endPoint: url,
    method: NetworkTypes.PUT,
    baseUrl: api.getUri(),
    data: postData,
  };

  await api
    .post(url, postData.bookingIds, {
      params: {
        origin: terminals.origin,
        destination: terminals.destination,
        loadingDate: terminals.loadingDate,
      },
    })
    .catch((error) => {
      throw handleAndThrowError(error, request);
    });

  return nonValidateBookings;
};
